export default "__VITE_ASSET__DjqMzVDg__"